<style coped>
.bg-primary {
  background-color: #1a3665 !important;
}
/* div#swal2-content {
  font-size: 16px;
  padding-top: 15px;
  padding-bottom: 15px;
} */
input.text-uppercase {
  text-transform: uppercase;
}

::-webkit-input-placeholder {
  text-transform: none;
}

:-moz-placeholder {
  text-transform: none;
}

::-moz-placeholder {
  text-transform: none;
}

:-ms-input-placeholder {
  text-transform: none;
}
</style>
<template>
 
    <CCard>
      <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
        Riwayat Peserta
      </CCardHeader>
      <!-- Data Sertifikasi -->
      <CCardBody>
        <CRow>
          <div class="col-sm-12 col-xl-12">
            <div class="form-group">
              <label for="" class="font-weight-bold">Pilih Level</label>
              <multiselect
                class="mulit-select"
                label="namaLevel"
                placeholder="Pilih Level"
                :show-labels="false"
                @select="pilihLevel"
                v-model="multi_kategori"
                required
                id="selectLevel"
                :options="optionMasterLevel"
                :loading="loading"
              ></multiselect>
            </div>
          </div>
          <div class="col-sm-12 col-xl-12">
            <div style="float:right">
              <button class="btn btn-info" @click="resetFilter">Reset Filter</button>&nbsp;
              <button class="btn btn-success" @click="filterData">Terapkan</button>
            </div>
          </div>
        </CRow>
        <CRow>
          <CCol xl="12">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
            <CInput
              label="Pencarian"
              class="float-right"
              placeholder="Cari Data .."
              v-model="search"            
            />
            <br />
          </CCol>
        </CRow>
        <CRow>
          <CCol lg="12" class="table-responsive">
            <CDataTable :items="items" :fields="fields" hover sorter>
              <template #no="{ index}">
                <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
              </template>
              <template #no_anggota="{item}">
                <td class="py-2">{{ item.no_anggota ? item.no_anggota  : '-' }}</td>
              </template>
              <template #jumlah_sertifikasi="{item}">
                <td class="py-2 text-center font-weight-bold">{{ item.jumlah_sertifikasi ? item.jumlah_sertifikasi : '-' }} Sertifikasi</td>
              </template>
              <template #aksi="{item}">
                <td class="py-2 text-center">
                  <template v-if="role_status && role_status.status_read">
                  <router-link :to="'/sertifikasi/riwayat-peserta/detail-riwayat-sertifikasi/'+item.iduser">
                    <CButton v-c-tooltip="'Detail'" color="success" class="btn-sm" square>
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    </CButton>
                  </router-link>
                  </template>
                  <template v-else>
                  <router-link v-c-tooltip="'Lihat Dokumen'" class="btn btn-sm btn-secondary text-white" 
                  square :to="'/sertifikasi/riwayat-peserta/detail-riwayat-sertifikasi/'+item.iduser"
                  tag="button"
                  :disabled="true"
                  >
                    <font-awesome-icon icon="file" />
                  </router-link>
                  </template>
                </td>
              </template>
            </CDataTable>
            <CPagination
              style="float:right"
              :active-page.sync="currentPage"
              :pages="pagination.totalPages"
              responsive
              @click="pageChange"
            />
          </CCol>
        </CRow>
      
      </CCardBody>
      <!-- end data kota/kab -->
    </CCard>
</template>

<script>
import RiwayatPesertaService from '@/services/sertifikasi/riwayat-peserta.service';
import { AlertUtils } from '@/mixins/AlertUtils';
import { PaginationRiwayatPeserta } from '@/mixins/paginationType/PaginationRiwayatPeserta';
import { Level } from "@/mixins/master/Level";

const fields = [
    { key: 'no', _style: 'width: 8%' },
    {
        key: 'no_anggota',
        label: 'Nomor Anggota ',
        _style: 'width: 18%'
    },
    {
        key: 'nama_lengkap',
        label: 'Nama Lengkap',
        _style: 'width: 18%'
    },
    {
        key: 'nama_level',
        label: 'Level Anggota',
        _style: 'width: 18%'
    },
    {
        key: 'jumlah_sertifikasi',
        label: 'Jumlah Sertifikasi',
        _style: 'width: 18%'
    },
    {
        key: "aksi",
        _style: "width:20%; text-align: center",
        sorter: false,
        filter: false
    }
];

export default {  
  mixins: [
    AlertUtils, 
    PaginationRiwayatPeserta,
    Level
  ],
  data() {
    return {
      actionPost: '',
      option_grader : [],
      multi_kategori: [],
      formData: {
        kodeMataUji: '',
        namaMataUji: '',
        nilaiMinimum: '',
        keterangan: '',
        graderSatu : '',
        graderDua : '',
        modelGraderSatu : [],
        modelGraderDua : [],
        status: '',
        statusGrader: '',
        idMasterMataUji: ''
      },
      fields,
      title: '',
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: 'col-3', input: 'col-9' },

      collapseDuration: 0,
      content: [],
      loading: true,
      role_status: null
    };
  },
  
  mounted() {
    this.tipe_halaman = 'all_data'
    this.getData('0', this.pageSize, this.search, 'default');
    this.getAllLevel();
    setTimeout(() => {
      this.loading = true;
      this.multi_kategori = this.items_master_level[0];
      this.loading = false;
    }, 1000)
    this.roleData()
  },

  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    },
    filterData() {
      this.getData('0', this.pageSize, this.search, this.idLevel);
    },
    resetFilter() {
      this.multi_kategori = []
      this.multi_kategori = []
      this.getData('0', this.pageSize, this.search);
    },
    pilihLevel(value){
      if(value.namaLevel == 'Semua Data') {
        this.idLevel = 'default';
      } else {
        this.idLevel = value.idLevelAnggota;
      }
    },

    pageChange() {
      this.getData(currentPage);
    },

    getData(currentPage, pageSize, filter,idLevel) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      RiwayatPesertaService.getRiwayatPesertaSertifikasi(currentPage, pageSize, filter,idLevel)
        .then(response => {
          // comment console console.log(response.data.data.content);
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;

          loader.hide();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
